module.exports = __webpack_public_path__ + "img/logo-16.eb1e905.jpg";